import { API } from "@/services"

export const PROCESS_LOGS_ENDPOINTS = {
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `process-logs`,
      method: 'GET',
      params,
    })
  },
  getById(id='',params={}){
    return API.Axios.universal_ai.v1.request({
      url: `process-logs/${id}`,
      method: 'GET',
      params,
    })
  },
  chart(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `process-logs/chart`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `process-logs/${id}`,
      method: 'DELETE',
      data,
    })
  },
}